<div #CheckoutContainer class="Grid Gap--larger Content">
    <table class="AttributeTable">
      <tr>
        <td>Item Number</td>
        <td>{{ itemNumber() }}</td>
      </tr>
    @for (attribute of attributeKeys(); track $index) {
      <tr>
        <td>{{ attribute }}</td>
        <td>
            @if (attribute === 'Engraving' && !getAttributeValue(attribute)) {
              No Engraving
            } @else {
              {{ getAttributeValue(attribute) }}
            }
        </td>
      </tr>
      @if (attribute === 'Engraving' && getAttributeValue(attribute) && selectedAttributes().engravingType) {
        <tr>
          <td>Engraving Type</td>
          <td>{{ selectedAttributes().engravingType?.displayName }}</td>
        </tr>
      }
    }
    @if (!!selectedAttributes().gemstoneType) {
      <tr>
        <td>Gemstone Total Weight</td>
        <td>{{ (selectedAttributes().gemstoneSize?.value ?? 0) * (stoneCount() ?? 0) }}ctw</td>
      </tr>
    }
    <tr>
      <td>
        <div class="PrintFix Flexbox Flexbox--column Align--flex-start Justify--center">
          <span>Retail Estimate</span>
        </div>
      </td>
      <td>
        <div class="Flexbox Flexbox--column">
          <app-price [price]="retailPrice()" [type]="'rounded-only'"></app-price>
        </div>
      </td>
    </tr>
  </table>

  <div class="PrintInstructions">
    <p>To order, simply <a class="PrintAnchor" (click)="print()">print</a> this page and bring it into our store.</p>
  </div>

  <div class="CheckoutContainer Flexbox Flexbox--column Gap--normal">
    <div class="Flexbox Align--center Gap--smaller ButtonContainer">
      <div class="NavButtons Flexbox Align--center Gap--smaller">
        <button mat-raised-button class="NavButton ShareButton ThemeColorAccent" #ShareButton (click)="shareClicked()">@if (shouldShowCopyConfirmation()) { Share url copied! }@else {Share Ring}</button>
        <button mat-raised-button class="NavButton AddToCart ThemeColorAccent" (click)="print()">Print</button>
      </div>
    </div>
  </div>
</div>
